import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import OpticksBackground from "@/components/ui/OpticksBackground/OpticksBackground";
import OpticksMessage from "@/components/ui/OpticksMessage/OpticksMessage";

const Forbidden = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const navEntry = performance.getEntriesByType("navigation")[0] as PerformanceNavigationTiming;
    if (navEntry?.type === "reload") {
      navigate("/", { replace: true });
    }
  }, [navigate]);

  return (
    <OpticksBackground>
      <OpticksMessage type="warning">
        <b>
          Your account can&apos;t be accessed at the moment. Please try again later.
        </b>{" "}
        <br /> The traffic is being analyzed and protected without disruption.
      </OpticksMessage>
    </OpticksBackground>
  );
};

export default Forbidden;
